module.exports = __webpack_public_path__ + "static/media/messages-cm.6e406c53.svg";